/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LinkRfidTagsRequest
 */
export interface LinkRfidTagsRequest {
    /**
     *
     * @type {Array<number>}
     * @memberof LinkRfidTagsRequest
     */
    rfidTagIds?: Array<number>;
}

/**
 * Check if a given object implements the LinkRfidTagsRequest interface.
 */
export function instanceOfLinkRfidTagsRequest(
    value: object,
): value is LinkRfidTagsRequest {
    return true;
}

export function LinkRfidTagsRequestFromJSON(json: any): LinkRfidTagsRequest {
    return LinkRfidTagsRequestFromJSONTyped(json, false);
}

export function LinkRfidTagsRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): LinkRfidTagsRequest {
    if (json == null) {
        return json;
    }
    return {
        rfidTagIds: json["rfidTagIds"] == null ? undefined : json["rfidTagIds"],
    };
}

export function LinkRfidTagsRequestToJSON(
    value?: LinkRfidTagsRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        rfidTagIds: value["rfidTagIds"],
    };
}
